/// <amd-module name="Analytics/Shared/Common/Types" />
import { IVssService } from "VSS/Platform/Context";

export enum ContextType {
    Build = 1,
    Release = 2
}

export interface IReportContext {
    contextType: ContextType;
    definitionId: number;
    definitionSK?: number;
}

export interface IODataQueryResponse {
    value: any;
    "@odata.nextLink": string;
    isCachedData: boolean;
}

export enum ViewType {
    NoTestDataView,
    ReportView,
    TestInsightsReportView,
    ErrorView,
    DataNotReadyView
}

export enum TrendBy {
    Hours = 0,
    Days = 1,
    Weeks = 2
}

// The enum values should be in increasing order of the
// number of days they represent.
export enum Period {
    Days_1 = 0,
    Days_7 = 1,
    Days_14 = 2,
    Days_30 = 3,
    Days_180 = 4
}

export interface IConfigurationProps {
    options: { [key: number]: string };
}

export interface ITrendData {
    startValue: number;
    endValue: number;
    percentageVariation: number;
    trendType: TrendType;
}

export enum TrendType {
    Increased,
    Decreased
}

export interface IAnalyticsDataService extends IVssService {
    fetchDefinitionName(definitionId: number): Promise<string>;
    getDefinitionUrl(definitionId: number): string;
    getAnalyticsCardMetricsUrl(definitionId: number): string;
}

export interface ITrendReportConfiguration {
    trendBy: TrendBy;
    period: Period;
}
